import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import i18n from "../i18n/i18n";
import { ErrorTranslateKey } from "../i18n/i18n.types";

type ApiResponse =
  | {
      data: unknown;
      error?: undefined;
    }
  | {
      data?: undefined;
      error: FetchBaseQueryError | SerializedError;
    };

interface ResponseHandlingOptions {
  onSuccess: (data: ApiResponse) => void;
  onError: (message: string | undefined) => void;
  fallbackErrorMessage?: string;
}

export const handleResponse = (
  response: ApiResponse,
  { onSuccess, onError, fallbackErrorMessage }: ResponseHandlingOptions
) => {
  if (response.error) {
    const error = (response.error as FetchBaseQueryError).data;
    if (error) {
      const responseErrorBody = (
        error as { error: { code: number; description: string } }
      ).error;
      const message =
        (i18n.t(responseErrorBody.description as ErrorTranslateKey, {
          ns: "errors",
        }) as string | undefined) || fallbackErrorMessage;
      onError(message);
    } else {
      onError(fallbackErrorMessage);
    }
  } else {
    onSuccess(response);
  }
};
